import { z } from 'zod';
import { DraftStudyDetailSchema, PublishedStudyDetailSchema } from './entity';

export const StudyPreviewWarningsSchema = z.object({
  incompleteFields: z.array(z.string()),
});

const WarningsSchema = z.object({
  warnings: StudyPreviewWarningsSchema,
});

export type StudyPreviewWarnings = z.infer<typeof StudyPreviewWarningsSchema>;

export const StudyPreviewDtoSchema = z.discriminatedUnion('status', [
  DraftStudyDetailSchema.merge(WarningsSchema),
  PublishedStudyDetailSchema.merge(WarningsSchema),
]);

export type StudyPreviewDto = z.infer<typeof StudyPreviewDtoSchema>;

export const PreviewTokenResponseSchema = z.object({
  token: z.string(),
  deepLink: z.string(),
  qrCode: z.string(),
  expiresAt: z.string().datetime(),
});

export type PreviewTokenResponse = z.infer<typeof PreviewTokenResponseSchema>;
